import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AppConfiguration } from './app-configuration';

@Injectable({
  providedIn: 'root',
})
export class AppConfigurationService {
  private configurationObject: AppConfiguration | undefined;

  constructor(private httpClient: HttpClient) {}

  public async loadConfigurations() {
    if (!this.configurationObject) {
      const configs$ = this.httpClient.get<AppConfiguration>(
        '/app-configuration.json'
      );
      this.configurationObject = await lastValueFrom(configs$);
    }
  }

  public getValue(key: string): string {
    if (!this.configurationObject) {
      throw new ReferenceError("AppConfigurationService isn't initialized");
    }
    return this.configurationObject[key as keyof AppConfiguration];
  }

  public async getValueAsync(key: string): Promise<string> {
    if (!this.configurationObject) {
      throw new ReferenceError("AppConfigurationService isn't initialized");
    }
    return this.getValue(key);
  }
}
